module.exports = __webpack_public_path__ + "img/6工作流设计.30118204.gif";